export enum LoginState {
    loading,
    loggedin,
    loggedout,
}
